import script from "./OrganizationContractRemoveDisciplineModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationContractRemoveDisciplineModal.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationContractRemoveDisciplineModal.vue?vue&type=style&index=0&id=136cd8ee&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-136cd8ee"]])

export default __exports__